import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { MinimizeIcon, MaximizeIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React__default, { useState, useContext } from 'react';
import useActiveElement from '../hooks/useActiveElement.js';
import FocusTrap from '../utils/FocusTrap.js';
import Button from './Button.js';

var _excluded = ["as", "className", "children", "initialIsVisibleState"],
  _excluded2 = ["className", "isVisible", "iconOnly"];
var FullScreenContext = /*#__PURE__*/React__default.createContext({
  isFullScreenActive: false
});
FullScreenContext.displayName = 'FullScreen.Context';
var FullScreen = function FullScreen(props) {
  props.as;
    var className = props.className,
    children = props.children,
    _props$initialIsVisib = props.initialIsVisibleState,
    initialIsVisibleState = _props$initialIsVisib === void 0 ? false : _props$initialIsVisib,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(initialIsVisibleState),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];

  // Cache the current focused dom element across re-renders
  var focusedElRef = useActiveElement(isVisible);
  var defaultOnRequestClose = function defaultOnRequestClose(event) {
    event.preventDefault();
    setIsVisible(false);
    props.onFullScreenToggle && props.onFullScreenToggle(false);
  };
  var defaultOnRequestOpen = function defaultOnRequestOpen(event) {
    setIsVisible(true);
    props.onFullScreenToggle && props.onFullScreenToggle(true);
  };
  var isFullScreenActive = props.isVisible === undefined ? isVisible : props.isVisible;
  var onEscape = function onEscape(event) {
    var onRequestClose = props.onRequestClose || defaultOnRequestClose;
    isFullScreenActive && onRequestClose(event);
  };
  var finalClasses = classnames('C-FullScreen', {
    isVisible: isFullScreenActive
  }, className);
  var parentProps = {
    isFullScreenActive: isFullScreenActive,
    onRequestClose: props.onRequestClose || defaultOnRequestClose,
    onRequestOpen: props.onRequestOpen || defaultOnRequestOpen
  };
  var conditionalTabIndex = isFullScreenActive ? {
    tabIndex: 0
  } : {};
  return /*#__PURE__*/React__default.createElement(FullScreenContext.Provider, {
    value: parentProps
  }, /*#__PURE__*/React__default.createElement(FocusTrap, _extends({
    as: "div",
    returnFocusTo: focusedElRef,
    onEscape: onEscape,
    active: isFullScreenActive,
    hidden: false
  }, conditionalTabIndex), /*#__PURE__*/React__default.createElement("div", _extends({
    "aria-modal": isFullScreenActive ? true : false,
    className: finalClasses
  }, otherProps), children)));
};
FullScreen.displayName = 'Fullscreen';
var FullScreenButton = function FullScreenButton(props) {
  var className = props.className;
    props.isVisible;
    var iconOnly = props.iconOnly,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var parentProps = useContext(FullScreenContext);
  var finalButtonClasses = classnames('C-FullScreenButton', className);
  return /*#__PURE__*/React__default.createElement(Button, _extends({}, otherProps, {
    iconOnly: iconOnly,
    className: finalButtonClasses,
    onClick: parentProps.isFullScreenActive ? parentProps.onRequestClose : parentProps.onRequestOpen
  }), /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    icon: parentProps.isFullScreenActive ? MinimizeIcon : MaximizeIcon
  }), !iconOnly && /*#__PURE__*/React__default.createElement("span", {
    className: "hc-ml-dense"
  }, parentProps.isFullScreenActive ? 'Exit Full Screen' : 'Full Screen'));
};
FullScreenButton.displayName = 'FullScreen.Button';
FullScreen.Button = FullScreenButton;

export { FullScreen, FullScreenContext, FullScreen as default };
